/**
 * Design tokens for the admin interface
 *
 * Centralized constants for spacing, typography, and other repeated values.
 * Use these tokens throughout the theme to maintain consistency.
 */

/**
 * Spacing tokens (values are MUI spacing units, where 1 = 8px)
 */
export const SPACING = {
  /** Default vertical spacing between major sections (cards, toolbars, etc.) */
  sectionVertical: 3, // 24px

  /** Card content padding */
  cardPadding: 3, // 24px

  /** Gap between related components */
  componentGap: 2, // 16px

  /** Small gap for tightly coupled elements */
  smallGap: 1, // 8px
} as const;

/**
 * Typography tokens
 */
export const TYPOGRAPHY = {
  /** Font weight for headers and emphasis */
  headerWeight: 'bold',

  /** Font weight for table headers */
  tableHeaderWeight: 'bold',

  /** Default font size for body text */
  defaultSize: '0.9rem',
} as const;

/**
 * Layout tokens
 */
export const LAYOUT = {
  /** Medium content width for edit pages and settings */
  mediumContentWidth: 900,

  /** Narrow content width for forms and creation pages */
  narrowContentWidth: 600,

  /** Standard table row height */
  tableRowHeight: 52, // px
} as const;

/**
 * Color tokens
 */
export const COLORS = {
  /** Active filter background color - light mode (bright yellow) */
  activeFilterBackgroundLight: '#fef3c7',
  /** Active filter background color - dark mode (dark yellow) */
  activeFilterBackgroundDark: '#854d0e',
} as const;
